import * as log from "../../ts/log";
import { Path } from "../../settings/interfaces";

let id: string = "";
let email: string = "";

export function init(): void {

  id = uuidv4();

}

export function runCondition(card: Path.ICard, params: any[]): void {

  const set = params[0];

  const setEntries = log.entries.filter(entry => {
    return entry.setGroup === set && entry.direction === "left";
  });

  if (setEntries.length === 0) {
    card.leftCard = `set${set + 1}-result1`;
    card.rightCard = `set${set + 1}-result1`;
  }

  if (setEntries.length === 1) {
    card.leftCard = `set${set + 1}-result1`;
    card.rightCard = `set${set + 1}-result2`;
  }
  if (setEntries.length === 2) {
    card.leftCard = `set${set + 1}-result2`;
    card.rightCard = `set${set + 1}-result2`;
  }
  if (setEntries.length === 3) {
    card.leftCard = `set${set + 1}-result2`;
    card.rightCard = `set${set + 1}-result3`;
  }
  if (setEntries.length >= 4) {
    card.leftCard = `set${set + 1}-result3`;
    card.rightCard = `set${set + 1}-result3`;
  }

}

export function resetSession(): void {

  id = uuidv4();
  email = "";
  log.clear();

}

const thankyouTemplate: string = `
<div>
  <div>
    <div class="heart4"></div>
    <div class="heart4 blue"></div>


    <h2>Thank you!</h2>
    <p>We will be in touch.<br><br><br><br><br><br></p>

    <span class="touch hint">Swipe up to restart</span>
    <span class="hint" data-swipe="top">Click here or drag up to restart</span>


  </div>

  <style>
    div.heart4:nth-child(1) { width:3em; left:6em; top:7em; }
    div.heart4:nth-child(2) { width:3em; left:9em; top:7em; }

    @media (orientation: landscape) {
      div.heart4:nth-child(1) { left: 1em; top: 2em; }
      div.heart4:nth-child(2) {  left: 4em; top: 2em; }
    }
  </style>

</div>`;

export function submitEmail(): void {

  const card = document.querySelector("#current-card") as HTMLDivElement;
  const emailInput = card.querySelector("input") as HTMLInputElement;
  const emailErrorMessage = card.querySelector("#error-message");

  console.log(card);

  if (validateEmail(emailInput.value)) {

    email = emailInput.value;

    submitLog(null, [(error: boolean = false) => {


      if (error) {

        emailInput.classList.add("invalid");
        (emailErrorMessage as HTMLParagraphElement).textContent = "There has been an issus. Please try again.";
        emailErrorMessage?.classList.add("show");

      } else {

        // go to THANK YOU page
        card.innerHTML = thankyouTemplate;

      }

    }]);

  } else {

    emailInput.classList.add("invalid");
    (emailErrorMessage as HTMLParagraphElement).textContent = "Please enter a valid email address.";
    emailErrorMessage?.classList.add("show");

  }

}

function validateEmail(email: string): boolean {
  var re = /[a-zA-Z0-9.\-&]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/;
  return re.test(String(email).trim());
}

export function submitLog(card: Path.ICard | null, params: any[]): void {

  const callback: (...args: any) => void = params[0];

  const data = {
    id,
    email,
    path: log.entries
  };

  const req = new XMLHttpRequest();
  req.open("POST", "https://love-api.breeio.com/api/values", true);
  req.setRequestHeader("Content-Type", "application/json");
  req.onreadystatechange = function() {
    try {
      if (this.readyState === 4) {
        if (this.status === 200) {
          // all good
          if (callback) callback();
        } else {
          // server error
          if (callback) callback(true);
          console.log("Error:", this.status);
        }
      }
    } catch (e) {

      if (callback) callback(true);
      console.log("Caught exception: " + e.description);

    }
  }
  req.send(JSON.stringify(data));
}

function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
